<template>
    <div class="item" v-if="is_snatch == 1 && mem_type != 2">
        <div class="item" v-show="TimeShow">
            <div class="item" v-if="TimeStatus != 1">
                <span class="fxn-font-size-16">距下一轮抢案开始时间：</span>
                <span class="hour fxn-text-org">{{myDay}}</span> 天
                <span class="hour fxn-text-org">{{myHours}}</span> 时
                <span class="minute fxn-text-org">{{myMinutes}}</span> 分
                <span class="second fxn-text-org">{{mySeconds}}</span> 秒
            </div>
            <div class="item" v-else>
                抢案已开始
                <el-button type="primary" @click="goSnatchList">去抢案</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                TimeShow: true,
                mem_type: '',               //主账号
                is_snatch: '',              //是否有权限抢案
            }
        },
        methods:{
            //跳转到抢案列表
            goSnatchList(){
                this.$router.push({ path: '/SnatchList' });
            },

            //获取下一次抢案时间
            NextTime(){                
                this.get('/osapi/snatchcases/getSnatchCaseTimeNext')
                .then(res=>{
                    let { msg, code, data } = res.data
                    if( code !==1 ){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.TimeStatus = res.data.data.jinxingzhong
                        this.is_snatch = res.data.data.is_snatch
                        let ServerTime = new Date();
                        let ServerStart = parseInt(ServerTime.getTime() / 1000)
                        if(res.data.data.jinxingzhong == 0){
                            if(res.data.data.snatchCaseTime == null || res.data.data.snatchCaseTime == ''){
                                this.TimeShow = false
                            }else{
                                this.start_time = res.data.data.snatchCaseTime.start_time   
                            }                                                   
                            let timeLag = (this.start_time - ServerStart)
                            let add = num => {
                                return num < 10 ? '0' + num : num
                            }
                            let timeFunction = () => {
                            let time = timeLag--
                            this.timeObj = {
                                seconds: Math.floor(time % 60),
                                minutes: Math.floor(time / 60) % 60,
                                hours: Math.floor(time / 60 / 60) % 24,
                                days: Math.floor(time / 60 / 60 / 24)
                            }
                            this.myDay = `${add(this.timeObj.days)}`
                            this.myHours = `${add(this.timeObj.hours)}`
                            this.myMinutes = `${add(this.timeObj.minutes)}`
                            this.mySeconds = `${add(this.timeObj.seconds)}`
                            if (time <= 0) {
                                this.isShow = true
                                this.clocker = this.endMsg || '该轮抢案已经结束'
                                clearInterval(go)
                            }
                            }
                            timeFunction()
                            let go = setInterval(() => {
                                timeFunction()
                            }, 1000)
                        }
                    }
                })
            },
        },
        mounted(){
            this.NextTime();

            //用户信息
            let user = JSON.parse(localStorage.getItem('user'));
			if (user) {
                this.mem_type = user.memberInfo.mem_type;
            }
        }
    }
</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/SnatchTime.vue